import api from './api';

export const menuService = {
  getAll: () => api.get('/menus'),
  getByCategory: (category) => api.get(`/menus/${category}`),
  update: (category, data) => api.put(`/menus/${category}`, data),
  addItem: (category, item) => api.post(`/menus/${category}/items`, item),
  removeItem: (category, itemId) => api.delete(`/menus/${category}/items/${itemId}`),
};